module.exports = __webpack_public_path__ + "assets/img/bdot10k.bb2bec43.png";